const localizationData = {
	da: {
		months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
		days: ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'],
		days2: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn']
	},
	kl: {
		months: ['Januaari', 'Februaari', 'Marsi', 'Apriili', 'Maaji', 'Juuni', 'Juuli', 'Aggusti', 'Septembari', 'Oktobari', 'Novembari', 'Decembari'],
		days: ['Ataas', 'Marl', 'Pinga', 'Sisa', 'Tall', 'Arf', 'Sap'],
		days2: ['Ataas', 'Marl', 'Pinga', 'Sisa', 'Tall', 'Arf', 'Sap']
	}
};

module.exports = {
	localizationData
};